module.exports = __webpack_public_path__ + "static/media/organization-form-icon.1c3a67cb.svg";